import { useState } from 'react';
import { jsx, css } from '@emotion/react';

import Image from './oc-image.jsx';
import Video from './oc-video.jsx';

import Modal from '../Modal';

const cardStyles = css`
  .video {
    display: block;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    &:hover, &:focus {
      color: #9f0d1d;
      text-decoration: underline;
    }

    img {
      width: 100%;
    }
  }

  .video::before {
    content: '\f03d';
    font-family: "fontawesome";
    color: white;
    font-size: 25px;
    text-shadow: 0 0 3px rgba(0, 0, 0, 0.75);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background: transparent;
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .video:hover:before {
    color: #d40f7d;
    background: white;
    text-shadow: none;
    text-decoration: none;
  }

  .video::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
  }

  .video:hover:after {
    background: rgba(212,15,125,0.5);
  }
`

const videoStyles = css`
  margin-top: 63px;
`

const VideoCard = ({ img, alt, url, children }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const toggleModalOpen = () => setModalOpen(!modalOpen)
return(
  <div className="oc-video-card" css={cardStyles}>
    <a onClick={toggleModalOpen} tabIndex="0" className="video" data-track="learn-more" data-track-destination={alt}>
      <Image src={img} alt={alt} />
    </a>
    <div className="text">
      {children}
    </div>

    <Modal open={modalOpen} onClose={toggleModalOpen} >
      <Video src={url} css={videoStyles} />
    </Modal>
  </div>
)};

export default VideoCard;
